export enum NotificationType {
  SUCCESS,
  ERROR,
  INFO,
}

export default interface Notification {
  type: NotificationType;
  title?: string | { key: string; opts?: any };
  localizedTitle?: string;
  message?: string | { key: string; opts?: any };
  localizedMessage?: string;
  time: number;
}
export { Notification };
